import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-business-setup-progress-loader',
  templateUrl: './business-setup-progress-loader.component.html',
  styleUrl: './business-setup-progress-loader.component.scss',
})
export class BusinessSetupProgressLoaderComponent {
  createBusinessAccount: boolean = false;
  values: number[] = [10, 40, 70, 100];
  currentIndex: number = 0;
  displayValue: number = 0;
  showFirstParagraph = false;
  showSecondParagraph = false;

  constructor(private _router: Router, private _active_route: ActivatedRoute) {}

  ngOnInit(): void {
    let type :any = this._active_route.snapshot.queryParamMap.get('type');
    if (type == 1) {
      this._router.navigate(['business-info']);
      return;
    } else {
      this.ProgressLoader();
    }
  }
  ProgressLoader() {
    this.createBusinessAccount = true;
    this.showFirstParagraph = true;
    this.showSecondParagraph = false;
    setTimeout(() => {
      this.showFirstParagraph = false;
      this.showSecondParagraph = true;
    }, 6000);
    this.showValues();
    setTimeout(() => {
      this.createBusinessAccount = false;
      this._router.navigate(['business-info']);
    }, 8000);
  }
  showValues() {
    this.displayNextValue();
  }
  displayNextValue() {
    if (this.currentIndex < this.values.length) {
      this.displayValue = this.values[this.currentIndex];
      this.currentIndex++;
      setTimeout(() => {
        this.displayNextValue();
      }, 2000); // Show the next value after 2 seconds
    }
  }
}
